import axios from "../plugins/parseAxios";
export class CustomerAPI {
  constructor(props) { }
  static getCustomers(payload) {
    return axios.post("functions/getCustomers", {
      projectId: payload.projectId,
    });
  }
  static getCustomer(payload) {
    return axios.post("functions/getCustomer", {
      id: payload.id,
    });
  }
  static createCustomer(payload) {
    return axios.post("functions/createCustomer", payload);
  }
  static updateCustomer(payload) {
    return axios.post("functions/updateCustomer", payload);
  }
  static getCustomerByKeyword(payload) {
    return axios.post("functions/getCustomerByKeyword", payload)
  }
  static getCustomersByMarket(payload) {
    return axios.post("functions/getCustomersByMarket", payload)
  }
  static getCustomersByProject(projectId, limit, page, order) {
    return axios.post("functions/getCustomersByProject", {
      projectId,
      limit,
      page,
      order,
    });
  }
  static getCustomersLengthByProject(projectId) {
    return axios.post("functions/getCustomersLengthByProject", { projectId })
  }
  static getDuplicateCustomers(payload) {
    return axios.post("functions/getDuplicateCustomers", payload)
  }
  static checkTaxID(payload) {
    return axios.post("functions/checkTaxID", payload)
  }
  static getCustomerByIds(payload) {
    return axios.post("functions/getCustomerByIds", payload);
  }
}
